module.exports = __webpack_public_path__ + "static/media/glycolic+e+fampoules.4aa1a5d4.png";